import { useEffect, useState } from 'react';

export const useCookieConsent = () => {
  const [cookieBotConsentStatistics, setCookieBotConsentStatistics] = useState<boolean>(
    Boolean(window.Cookiebot?.consent?.statistics)
  );

  useEffect(() => {
    const handleAccept = () => {
      setCookieBotConsentStatistics(Boolean(window.Cookiebot?.consent?.statistics));
    };
    const handleDecline = () => {
      setCookieBotConsentStatistics(false);
    };
    window.addEventListener('CookiebotOnAccept', handleAccept);
    window.addEventListener('CookiebotOnDecline', handleDecline);
    return () => {
      window.removeEventListener('CookiebotOnAccept', handleAccept);
      window.removeEventListener('CookiebotOnDecline', handleDecline);
    };
  }, []);
  return { cookieBotConsentStatistics };
};
